import {
  Appear,
  BlockQuote,
  Cite,
  Code,
  Fill,
  Fit,
  Heading,
  Image,
  Layout,
  Link,
  List,
  ListItem,
  Quote,
  S,
  Text
} from '@jimpick/spectacle/src/spectacle';
import preloader from '@jimpick/spectacle/src/utils/preloader';

// Customized
import Deck from './deck';
import Slide from './slide';

// New additions
import Fullscreen from './fullscreen';
import Section from './section';

const spectacle = {
  Appear,
  BlockQuote,
  Cite,
  Code,
  Deck,
  Fill,
  Fit,
  Heading,
  Image,
  Layout,
  Link,
  List,
  ListItem,
  Quote,
  S,
  Slide,
  Text,
  Fullscreen,
  Section,
  preloader
};

export default spectacle;



// WEBPACK FOOTER //
// ./src/views/session/presentation/spectacle-ppa/src/spectacle.js